const fileReducer = (state={}, action) => {
    switch (action.type){
        case 'SET_UPLOAD':{
            let newState = {...state}
            newState[action.id] = action.upload
            return state = newState;
        }
        case 'REMOVE_STATE_UPLOAD':{
            let newState = {...state}
            newState = {}
            return state = newState
        }
        case 'REMOVE_ELEMENT':{
            let newState = {...state}
            if(action.index >= 0){
                newState[action.id].splice(action.index, 1);
                return state = newState
            }
            else{
                delete newState[action.id]
                return state = newState
            }
        }
        default : return state
    }
}

export default fileReducer
